module.exports = "/assets/images/edit_95dc2c.svg";